import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

class TransferCheckSummary extends Component {
  addItemsToMap(itemsMap, items, quantityKey) {
    if (!items) {
      return;
    }

    items.forEach(item => {
      itemsMap[item.sku] = {
        ...itemsMap[item.sku],
        sku: item.sku,
        [quantityKey]: item.quantity,
      };
    });
  }

  render() {
    const { classes, products, receivedOrders, getProduct, onBack, onFinish } = this.props;
    const { expectedItems, transferInItems, segregatedItems } = receivedOrders;

    const itemsMap = {};

    this.addItemsToMap(itemsMap, expectedItems, 'expected');
    this.addItemsToMap(itemsMap, transferInItems, 'received');
    this.addItemsToMap(itemsMap, segregatedItems, 'segregated');
    return (
      <Paper elevation={1} className={classes.noOrdersCardPaper}>
        <Grid container direction="column" alignItems="center" spacing={16}>
          <Grid item>
            <Typography variant="h6">
              Resumo dos produtos enviados e recebidos
            </Typography>
          </Grid>
          <Grid item xs={12} style={{ width: '100%', overflowX: 'auto' }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.summaryTableHeader}>SKU</TableCell>
                  <TableCell className={classes.summaryTableHeader}>Descrição</TableCell>
                  <TableCell align="right" className={classes.summaryTableHeader}>Qtd. Enviada</TableCell>
                  <TableCell align="right" className={classes.summaryTableHeader}>Qtd. Recebida</TableCell>
                  <TableCell align="right" className={classes.summaryTableHeader}>Qtd. Vendável</TableCell>
                  <TableCell align="right" className={classes.summaryTableHeader}>Qtd. Segregada</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.values(itemsMap).sort((a, b) => a.sku.localeCompare(b.sku)).map(item => {
                  const [, { name }] = getProduct(products, { sku: item.sku });
                  return (
                    <TableRow key={item.sku}>
                      <TableCell component="th" scope="row" className={classes.summaryTableCell}>
                        {item.sku}
                      </TableCell>
                      <TableCell className={classes.summaryTableCell}>
                        {name}
                      </TableCell>
                      <TableCell align="right" className={classes.summaryTableCell}>{item.expected || 0}</TableCell>
                      <TableCell align="right" className={classes.summaryTableCell}>{(item.received || 0) + (item.segregated || 0)}</TableCell>
                      <TableCell align="right" className={classes.summaryTableCell}>{item.received || 0}</TableCell>
                      <TableCell align="right" className={classes.summaryTableCell}>{item.segregated || 0}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Grid>
          <Grid item container justify="center" spacing={16}>
            <Grid item>
              <Button
                variant="contained"
                color="secondary"
                onClick={onBack}
              >
                Voltar
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={onFinish}
              >
                Finalizar recebimento
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

TransferCheckSummary.propTypes = {
  classes: PropTypes.object.isRequired,
  products: PropTypes.object.isRequired,
  receivedOrders: PropTypes.object.isRequired,
  getProduct: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onFinish: PropTypes.func.isRequired,
};

export default TransferCheckSummary;
